const CAROUSEL_ITEMS = [
  {
    tag: '悬疑推理',
    title: '烧脑悬疑漫精选',
    desc: '层层反转的高智商推理，每一页都让人屏息凝神，不到最后一格绝不知道真相。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20silhouette%20and%20dramatic%20lighting%2C%20noir%20style%20cityscape%20at%20night%2C%20foggy%20alleyway%20with%20warm%20streetlamp%2C%20suspenseful%20mood%2C%20stylized%20illustration%2C%20rich%20contrast%20between%20deep%20shadows%20and%20warm%20light%2C%20no%20text%20no%20letters%2C%20cinematic%20composition&width=800&height=500&seq=manga-focus-01&orientation=landscape',
  },
  {
    tag: '恋爱甜宠',
    title: '高甜恋爱漫画合集',
    desc: '从校园青涩到都市热恋，每一帧都让人心动不已，糖分超标的甜宠日常。',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20spring%20scene%20with%20cherry%20blossoms%20falling%2C%20warm%20golden%20sunlight%20through%20trees%2C%20dreamy%20pastel%20color%20palette%20of%20pink%20and%20cream%2C%20gentle%20atmosphere%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20soft%20bokeh%20effect&width=800&height=500&seq=manga-focus-02&orientation=landscape',
  },
  {
    tag: '搞笑日常',
    title: '笑到停不下来的搞笑漫',
    desc: '脑洞大开的爆笑日常，神仙作者在线造梗，治愈一切不开心。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20playful%20colorful%20scene%20with%20whimsical%20elements%2C%20comic%20style%20pop%20art%20aesthetic%2C%20vibrant%20warm%20colors%20of%20orange%20yellow%20and%20coral%2C%20fun%20energetic%20mood%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20dynamic%20composition%20with%20speech%20bubble%20shapes&width=800&height=500&seq=manga-focus-03&orientation=landscape',
  },
  {
    tag: '韩漫精选',
    title: '韩漫人气榜TOP推荐',
    desc: '色彩绚丽的韩式条漫，从古风奇幻到现代都市，视觉冲击与剧情张力兼具。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20style%20illustration%20with%20flowing%20fabrics%20and%20delicate%20ornaments%2C%20soft%20gradient%20background%20of%20coral%20and%20cream%2C%20traditional%20and%20modern%20fusion%20aesthetic%2C%20stylized%20flat%20illustration%2C%20no%20text%20no%20letters%2C%20dreamy%20atmosphere%20with%20floating%20petals&width=800&height=500&seq=manga-focus-04&orientation=landscape',
  },
  {
    tag: '日漫经典',
    title: '日漫殿堂级作品巡礼',
    desc: '从少年热血到少女治愈，经典日漫一网打尽，重温那些年追过的神作。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20aesthetic%20scene%20with%20clean%20lines%20and%20soft%20colors%2C%20cityscape%20at%20sunset%20with%20warm%20orange%20sky%2C%20nostalgic%20school%20rooftop%20setting%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20emotional%20atmosphere%2C%20delicate%20linework&width=800&height=500&seq=manga-focus-05&orientation=landscape',
  },
  {
    tag: '国漫崛起',
    title: '国漫新锐力量盘点',
    desc: '画风精美、剧情扎实的国产漫画正在崛起，古风武侠与现代都市题材百花齐放。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20landscape%20with%20misty%20mountains%20and%20flowing%20water%2C%20traditional%20and%20modern%20fusion%2C%20warm%20earth%20tones%20of%20terracotta%20and%20cream%2C%20elegant%20composition%20with%20pine%20trees%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20serene%20atmosphere&width=800&height=500&seq=manga-focus-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            六大品类精选，发现你的下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 谜妹漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}